var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenNoSins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "127px",
    viewBox: "0 0 124 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Token-NoSins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 62,
    cy: 62,
    r: 62
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.2%",
    width: "102.4%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,28 L30,28 L30,34 L0,34 L0,28 Z M37,28 L40,28 L40,34 L37,34 L37,28 Z M32,28 L35,28 L35,34 L32,34 L32,28 Z M33.7,11.46 C34.94,10.24 35.7,8.56 35.7,6.7 C35.7,3 32.7,0 29,0 L29,3 C31.04,3 32.7,4.66 32.7,6.7 C32.7,8.74 31.04,10.4 29,10.4 L29,13.4 C33.48,13.4 37,17.06 37,21.54 L37,26 L40,26 L40,21.52 C40,17.08 37.44,13.24 33.7,11.46 L33.7,11.46 Z M28.06,16.4 L25,16.4 C22.96,16.4 21.3,14.44 21.3,12.4 C21.3,10.36 22.96,8.9 25,8.9 L25,5.9 C21.3,5.9 18.3,8.9 18.3,12.6 C18.3,16.3 21.3,19.3 25,19.3 L28.06,19.3 C30.16,19.3 32,20.78 32,23.4 L32,26 L35,26 L35,22.72 C35,19.1 31.8,16.4 28.06,16.4 L28.06,16.4 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\"ESG\"-Game-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ESG/S/Q1-b/Q2-b/Q3",
    transform: "translate(-237.000000, -391.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(24.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(183.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Token-NoSins",
    transform: "translate(30.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 5.000000)",
    id: "ic_favorite"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.16,2 L44.16,2 L44.16,10 L42.16,10 L42.16,12 L30.16,12 C29.0554305,12 28.16,12.8954305 28.16,14 L28.16,16 C28.16,18.209139 26.369139,20 24.16,20 L17.4,20 C16.64,20 15.94,20.44 15.6,21.12 L10.7,30.9 C10.36,31.58 9.68,32 8.92,32 L2.16,32 C2.16,32 -3.84,32 4.16,20 C4.16,20 10.16,12 2.16,12 L2.16,2 L4.16,2 L5.16,0 L11.16,0 L12.16,2 M26.16,16 L26.16,14 C26.16,12.8954305 25.2645695,12 24.16,12 L22.16,12 C22.16,12 20.16,14 22.16,16 C19.950861,16 18.16,14.209139 18.16,12 C17.0554305,12 16.16,12.8954305 16.16,14 L16.16,16 C16.16,17.1045695 17.0554305,18 18.16,18 L24.16,18 C25.2645695,18 26.16,17.1045695 26.16,16 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,14 C26.8954305,14 26,13.1045695 26,12 C26,10.8954305 26.8954305,10 28,10 C29.1045695,10 30,10.8954305 30,12 C30,13.1045695 29.1045695,14 28,14 M16,14 L4,14 L4,4 L16,4 M31.54,8.46 L31.56,8.44 L24.12,1 L22,3.12 L26.22,7.34 C24.34,8 23,9.86 23,12 C23,14.7614237 25.2385763,17 28,17 C28.72,17 29.38,16.84 30,16.58 L30,31 C30,32.1045695 29.1045695,33 28,33 C26.8954305,33 26,32.1045695 26,31 L26,22 C26,19.78 24.2,18 22,18 L20,18 L20,4 C20,1.78 18.2,0 16,0 L4,0 C1.78,0 0,1.78 0,4 L0,36 L20,36 L20,21 L23,21 L23,31 C23,33.7614237 25.2385763,36 28,36 C29.3260824,36 30.597852,35.4732158 31.5355339,34.5355339 C32.4732158,33.597852 33,32.3260824 33,31 L33,12 C33,10.62 32.44,9.36 31.54,8.46 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,24 C0,26.6 1.6,28.8 4,29.6 L4,36 L0,36 L0,40 L12,40 L12,36 L8,36 L8,29.6 C10.4,28.8 12,26.6 12,24 L12,8 L0,8 L0,24 M4,12 L8,12 L8,18 L4,18 L4,12 M35.2,13 L33.2,12.4 C32.6,12.2 32,11.4 32,10.6 L32,2 C32,1 31,0 30,0 L24,0 C22.8,0 22,1 22,2 L22,10.6 C22,11.4 21.4,12.2 20.6,12.6 L18.8,13.2 C17.2,13.8 16,15.2 16,17 L16,36 C16,38.2 17.8,40 20,40 L34,40 C36.2,40 38,38.2 38,36 L38,16.8 C38,15.2 37,13.6 35.2,13 M26,4 L28,4 L28,6 L26,6 L26,4 M20,16.8 L21.8,16.2 C24.4,15.4 26,13.2 26,10.6 L26,10 L28,10 L28,10.6 C28,13.2 29.6,15.4 32,16.2 L34,16.8 L34,20 L20,20 L20,16.8 M34,36 L20,36 L20,32 L34,32 L34,36 Z",
    id: "Shape",
    fill: "#575F69"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62,-1 C77.7084591,-1 92.0740733,4.74922086 103.107661,14.2580571 L103.599469,14.6863318 L109.396591,20.3003121 C119.074845,31.4898564 125,46.0531322 125,62 C125,79.3969696 117.948485,95.1469696 106.547727,106.547727 C95.1469696,117.948485 79.3969696,125 62,125 C46.2915409,125 31.9259267,119.250779 20.8923388,109.741943 L20.400531,109.313668 L14.6034086,103.699688 C4.92515481,92.5101436 -1,77.9468678 -1,62 C-1,44.6030304 6.05151519,28.8530304 17.4522728,17.4522728 C28.8530304,6.05151519 44.6030304,-1 62,-1 Z M102.846045,28.2249355 L28.2249355,102.846045 L28.7015811,103.236006 C37.8015865,110.593638 49.3862349,115 62,115 C76.6355459,115 89.8855459,109.067773 99.4766594,99.4766594 C109.067773,89.8855459 115,76.6355459 115,62 C115,49.1649408 110.437673,37.3954244 102.846045,28.2249355 L102.846045,28.2249355 Z M62,9 C47.3644541,9 34.1144541,14.9322271 24.5233406,24.5233406 C14.9322271,34.1144541 9,47.3644541 9,62 C9,74.8350592 13.5623269,86.6045756 21.1539546,95.7750645 L21.1539546,95.7750645 L95.7750645,21.1539546 L95.2984189,20.7639936 C86.1984135,13.4063615 74.6137651,9 62,9 Z",
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FF5F5F",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenNoSins);
export default __webpack_public_path__ + "static/media/Token-NoSins.dde41327d503a57f295c18bbd00d0571.svg";
export { ForwardRef as ReactComponent };